const DragZone = () => (
  <div
    aria-hidden
    id='draggable'
    className='z-[99] absolute top-0 w-full h-16 bg-transparent'
  />
);

export default DragZone;
